import TeacherScheduleList from './list';
import { TeacherScheduleLoader } from './provider/TeacherScheduleLoader';

export default function TeacherSchedule() {
  return (
    <TeacherScheduleLoader>
      <TeacherScheduleList />
    </TeacherScheduleLoader>
  );
}
